import {
  FETCH_SINGLE_CONTACT_CONTENT,
  FETCH_SINGLE_CONTACT_CONTENT_SUCCESS,
  FETCH_SINGLE_CONTACT_CONTENT_FAILED,
  SINGLE_CONTACT_MESSAGE,
  SINGLE_CONTACT_MESSAGE_SUCCESS,
  SINGLE_CONTACT_MESSAGE_FAILED,
  FETCH_CONTACTS_CONTENT,
  FETCH_CONTACTS_CONTENT_FAILED,
  FETCH_CONTACTS_CONTENT_SUCCESS,
  CONTACT_DELETE__MESSAGE,
  CONTACT_DELETE_MESSAGE_SUCCESS,
  CONTACT_DELETE__MESSAGE_FAILED,
  GET_FILTER_CONTACT,
  GET_FILTER_CONTACT_FAILED,
  GET_FILTER_CONTACT_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  content: {},
  error: false,
  isFormProcessing: false,
  emptyFormData: false,
  floor_plans: [],
  isFilterLoading: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_FILTER_CONTACT:
      return {
        ...state,
        isFilterLoading: true,
      };
    case GET_FILTER_CONTACT_SUCCESS:
      return {
        ...state,
        isFilterLoading: false,
        content: payload,
      };

    case GET_FILTER_CONTACT_FAILED:
      return {
        ...state,
        isFilterLoading: false,
        error: payload,
      };
    case FETCH_CONTACTS_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {},
      };
    case FETCH_CONTACTS_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
      };
    case FETCH_CONTACTS_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case FETCH_SINGLE_CONTACT_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {},
      };
    case FETCH_SINGLE_CONTACT_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
      };
    case FETCH_SINGLE_CONTACT_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case SINGLE_CONTACT_MESSAGE:
      return {
        ...state,
        isFormProcessing: true,
      };
    case SINGLE_CONTACT_MESSAGE_SUCCESS:
      return {
        ...state,
        isFormProcessing: false,
        emptyFormData: true,
      };
    case SINGLE_CONTACT_MESSAGE_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        error: payload,
      };
    case CONTACT_DELETE__MESSAGE:
      return {
        ...state,
        isFormProcessing: true,
      };
    case CONTACT_DELETE_MESSAGE_SUCCESS:
      return {
        ...state,
        isFormProcessing: false,
        emptyFormData: true,
      };
    case CONTACT_DELETE__MESSAGE_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        error: payload,
      };
    default:
      return state;
  }
}
